import { NotificationList, ResponseError } from "@wingspanhq/wingspan-api-sdk";
import { WSQueryConfig } from "@ws-react-query";
import { queriesNotifications } from "@query";
import { useSession } from "@hooks/useSession";
import { WSNotificationResponse } from "../../../modules/Dashboard/components/Notifications";

export const useQueryNotifications = (
  queryConfig?: WSQueryConfig<
    NotificationList,
    ResponseError,
    WSNotificationResponse[]
  >
) => {
  const { personId, accountId } = useSession();

  return queriesNotifications.listNotifications.useQuery(
    { personId, filter: { subjectAccountId: { eq: accountId } } },
    {
      ...queryConfig,
      enabled: !!personId && queryConfig?.enabled !== false,
      select: list => (list.data ?? []) as unknown as WSNotificationResponse[]
    }
  );
};
